// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__M61g-","top":"styles_top__wO3_D","left":"styles_left__3Nduo","description":"styles_description__1HquO"};